var React = require('react');

function BrowserExtension (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 10h34a1 1 0 0 1 1 1v5H6v-5a1 1 0 0 1 1-1zm-1 8v19a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V18H6zm-2-7a3 3 0 0 1 3-3h34a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V11zm6 3H8v-2h2v2zm17 14h12v-7H27v7zM14 14h-2v-2h2v2zm2 0h2v-2h-2v2z","fill":"#fff"}));
}

BrowserExtension.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = BrowserExtension;

BrowserExtension.default = BrowserExtension;
